import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Financeiro() {
  const [financeiroList, setFinanceiroList] = useState([]);
  
  const [descricao, setDescricao] = useState('');
  const [tipo, setTipo] = useState('Contas a Receber');
  const [valor, setValor] = useState('');
  const [vencimento, setVencimento] = useState('');
  const [status, setStatus] = useState('Em Andamento');
  
  const [editandoId, setEditandoId] = useState(null);

  // Estados para os Filtros
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('Todos');

  useEffect(() => {
    carregarFinanceiro();
  }, []);

  const carregarFinanceiro = async () => {
    try {
      const res = await api.get('/financeiro');
      setFinanceiroList(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Erro ao carregar financeiro:", err);
    }
  };

  const adicionarLancamento = async () => {
    if (descricao && valor && vencimento) {
      const finId = editandoId || Date.now().toString();
      const novoFin = { 
        id: finId, 
        descricao, 
        tipo, 
        valor: parseFloat(valor.replace(',', '.')) || 0, 
        vencimento, 
        status 
      };

      try {
        if (editandoId) {
          await api.put(`/financeiro/${editandoId}`, novoFin);
        } else {
          await api.post('/financeiro', novoFin);
        }

        {
          carregarFinanceiro();
          limparFormulario();
          alert(editandoId ? 'Lançamento atualizado com sucesso!' : 'Lançamento salvo com sucesso!');
        }
      } catch (err) { 
        console.error(err); 
        alert('Erro de conexão ao salvar lançamento.'); 
      }
    } else {
      alert('Preencha todos os campos obrigatórios.');
    }
  };

  const iniciarEdicao = (f) => {
    setEditandoId(f.id);
    setDescricao(f.descricao);
    setTipo(f.tipo === 'Receita' ? 'Contas a Receber' : 'Contas a Pagar');
    setValor(f.valor);
    setVencimento(f.vencimento);
    setStatus(f.status || 'Em Andamento');
  };

  const limparFormulario = () => {
    setEditandoId(null);
    setDescricao(''); setValor(''); setVencimento(''); setStatus('Em Andamento'); setTipo('Contas a Receber');
  };

  const excluirLancamento = async (id) => {
    if (!window.confirm("Deseja realmente excluir este lançamento financeiro?")) return;
    try {
      await api.delete(`/financeiro/${id}`);
      await carregarFinanceiro();
    } catch (err) { 
      console.error(err); 
      alert('Erro de conexão ao excluir lançamento.'); 
    }
  };

  // Aplicação dos Filtros (Período e Tipo) sobre a lista carregada
  const listaFiltrada = financeiroList.filter(item => {
    const isReceita = item.tipo === 'Receita' || item.tipo === 'Contas a Receber';
    const tipoFormatado = isReceita ? 'Contas a Receber' : 'Contas a Pagar';

    if (filtroTipo !== 'Todos' && tipoFormatado !== filtroTipo) return false;
    if (item.vencimento) {
      if (dataInicio && item.vencimento < dataInicio) return false;
      if (dataFim && item.vencimento > dataFim) return false;
    }
    return true;
  });

  // Cálculo dos totais baseado na lista filtrada
  const totalReceber = listaFiltrada
    .filter(f => f.tipo === 'Receita' || f.tipo === 'Contas a Receber')
    .reduce((acc, curr) => acc + Number(curr.valor || 0), 0);

  const totalPagar = listaFiltrada
    .filter(f => f.tipo === 'Despesa' || f.tipo === 'Contas a Pagar')
    .reduce((acc, curr) => acc + Number(curr.valor || 0), 0);

  const saldoLiquido = totalReceber - totalPagar;

  return (
    <div style={{ width: '100%', boxSizing: 'border-box', padding: '20px', color: '#fff' }}>
      <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0 0 20px 0' }}>Módulo Financeiro (Contas a Pagar & Receber)</h2>

      {/* Cards de Resumo */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
        <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '12px', color: '#a0a0a0' }}>Total a Receber (Período)</span>
          <p style={{ fontSize: '26px', fontWeight: '800', color: '#32D74B', margin: '8px 0 0 0' }}>
            R$ {totalReceber.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '12px', color: '#a0a0a0' }}>Total a Pagar (Período)</span>
          <p style={{ fontSize: '26px', fontWeight: '800', color: '#FF3B30', margin: '8px 0 0 0' }}>
            R$ {totalPagar.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '12px', color: '#a0a0a0' }}>Saldo Líquido</span>
          <p style={{ fontSize: '26px', fontWeight: '800', color: saldoLiquido >= 0 ? '#007AFF' : '#FF3B30', margin: '8px 0 0 0' }}>
            R$ {saldoLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
      </div>

      {/* Formulário de Novo / Editar Lançamento */}
      <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>{editandoId ? '✏️ Editar Lançamento' : 'Novo Lançamento Financeiro'}</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr auto', gap: '12px', alignItems: 'end' }}>
          <div>
            <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>DESCRIÇÃO</label>
            <input placeholder="Descrição" value={descricao} onChange={e => setDescricao(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>TIPO</label>
            <select value={tipo} onChange={e => setTipo(e.target.value)} style={inputStyle}>
              <option value="Contas a Receber">Contas a Receber</option>
              <option value="Contas a Pagar">Contas a Pagar</option>
            </select>
          </div>
          <div>
            <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>VALOR (R$)</label>
            <input placeholder="Ex: 150.00" value={valor} onChange={e => setValor(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>VENCIMENTO</label>
            <input type="date" value={vencimento} onChange={e => setVencimento(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: '11px', color: '#a0a0a0', display: 'block', marginBottom: '4px' }}>STATUS</label>
            <select value={status} onChange={e => setStatus(e.target.value)} style={inputStyle}>
              <option value="Em Andamento">Em Andamento</option>
              <option value="Pendente">Pendente</option>
              <option value="Concluído">Concluído</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: '6px' }}>
            <button onClick={adicionarLancamento} style={{ padding: '10px 18px', backgroundColor: editandoId ? '#f0ad4e' : '#007AFF', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
              {editandoId ? 'Atualizar' : 'Salvar'}
            </button>
            {editandoId && (
              <button onClick={limparFormulario} style={{ padding: '10px 12px', backgroundColor: '#444', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>X</button>
            )}
          </div>
        </div>
      </div>

      {/* Barra de Filtros (Período e Tipo) */}
      <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', padding: '16px', borderRadius: '8px', marginBottom: '20px', display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#a0a0a0' }}>🔍 Filtros:</span>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontSize: '12px', color: '#888' }}>Tipo:</label>
          <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)} style={inputStyleFilter}>
            <option value="Todos">Todos os Tipos</option>
            <option value="Contas a Receber">Contas a Receber</option>
            <option value="Contas a Pagar">Contas a Pagar</option>
          </select>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontSize: '12px', color: '#888' }}>De:</label>
          <input type="date" value={dataInicio} onChange={e => setDataInicio(e.target.value)} style={inputStyleFilter} />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontSize: '12px', color: '#888' }}>Até:</label>
          <input type="date" value={dataFim} onChange={e => setDataFim(e.target.value)} style={inputStyleFilter} />
        </div>

        {(dataInicio || dataFim || filtroTipo !== 'Todos') && (
          <button onClick={() => { setDataInicio(''); setDataFim(''); setFiltroTipo('Todos'); }} style={{ padding: '6px 12px', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>
            Limpar Filtros
          </button>
        )}
      </div>

      {/* Tabela de Lançamentos */}
      <div style={{ backgroundColor: '#141414', border: '1px solid #2a2a2a', borderRadius: '8px', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #2a2a2a', color: '#a0a0a0', backgroundColor: '#1a1a1a' }}>
              <th style={{ padding: '16px' }}>Descrição</th>
              <th style={{ padding: '16px' }}>Tipo</th>
              <th style={{ padding: '16px' }}>Vencimento</th>
              <th style={{ padding: '16px' }}>Valor</th>
              <th style={{ padding: '16px' }}>Status</th>
              <th style={{ padding: '16px', textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {listaFiltrada.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#777' }}>Nenhum lançamento encontrado para os filtros selecionados.</td>
              </tr>
            ) : (
              listaFiltrada.map(item => {
                const isReceita = item.tipo === 'Receita' || item.tipo === 'Contas a Receber';
                return (
                  <tr key={item.id} style={{ borderBottom: '1px solid #222' }}>
                    <td style={{ padding: '16px', fontWeight: 'bold' }}>{item.descricao}</td>
                    <td style={{ padding: '16px', color: isReceita ? '#32D74B' : '#FF3B30', fontWeight: 'bold' }}>
                      {isReceita ? 'Contas a Receber' : 'Contas a Pagar'}
                    </td>
                    <td style={{ padding: '16px', fontFamily: 'monospace' }}>{item.vencimento}</td>
                    <td style={{ padding: '16px', color: isReceita ? '#32D74B' : '#FF3B30', fontWeight: 'bold' }}>
                      R$ {Number(item.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: '16px', color: '#FFD60A', fontWeight: 'bold' }}>{item.status || 'Em Andamento'}</td>
                    <td style={{ padding: '16px', textAlign: 'right' }}>
                      <button onClick={() => iniciarEdicao(item)} style={{ padding: '6px 12px', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '4px', marginRight: '8px', cursor: 'pointer' }}>Editar</button>
                      <button onClick={() => excluirLancamento(item.id)} style={{ padding: '6px 12px', backgroundColor: '#FF3B30', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Excluir</button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const inputStyle = { width: '100%', padding: '10px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box' };
const inputStyleFilter = { padding: '8px 12px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff' };